
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Ana Sayfa', href: '/' },
    { name: 'Hakkımızda', href: '/hakkimizda' },
    { name: 'Ürünler', href: '/urunler', hasDropdown: true },
    { name: 'Hizmetler', href: '/hizmetler' },
    { name: 'İletişim', href: '/iletisim' }
  ];

  const productCategories = [
    { 
      name: 'Cıvatalar', 
      href: '/urunler',
      subCategories: [
        { name: 'İmbus Cıvatalar', href: '/urun-kategori/cıvatalar/imbus-civatalar' },
        { name: 'AKB Cıvatalar', href: '/urun-kategori/cıvatalar/akb-civatalar' },
        { name: 'Setskurlar', href: '/urun-kategori/cıvatalar/setskurlar' },
        { name: 'Diğer', href: '/urun-kategori/cıvatalar/diger-civatalar' }
      ]
    },
    { 
      name: 'Somunlar', 
      href: '/urunler',
      subCategories: [
        { name: 'Standart Somunlar', href: '/urun-kategori/somunlar/standart-somunlar' },
        { name: 'Özel Somunlar', href: '/urun-kategori/somunlar/ozel-somunlar' }
      ]
    },
    { 
      name: 'Vidalar', 
      href: '/urunler',
      subCategories: [
        { name: 'Metrik Vidalar', href: '/urun-kategori/vidalar/metrik-vidalar' },
        { name: 'Sac Vidaları', href: '/urun-kategori/vidalar/sac-vidalari' },
        { name: 'Matkap Uçlu Vidalar', href: '/urun-kategori/vidalar/matkap-uclu-vidalar' },
        { name: 'Ahşap Vidaları', href: '/urun-kategori/vidalar/ahsap-vidalari' }
      ]
    },
    { 
      name: 'Rondelalar', 
      href: '/urunler',
      subCategories: [
        { name: 'Rondelalar', href: '/urun-kategori/rondelalar/rondelalar' }
      ]
    }
  ];

  return (
    <header className="bg-slate-900 text-white sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-4xl font-black tracking-wider" style={{ fontFamily: 'Exo 2, sans-serif' }}>
              NBA CIVATA
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <div key={item.name} className="relative">
                {item.hasDropdown ? (
                  <div
                    className="relative"
                    onMouseEnter={() => setIsProductsDropdownOpen(true)}
                    onMouseLeave={() => setIsProductsDropdownOpen(false)}
                  >
                    <Link
                      to={item.href}
                      className={`text-lg font-medium transition-colors hover:text-orange-400 flex items-center ${
                        location.pathname === item.href ? 'text-orange-400' : 'text-gray-300'
                      }`}
                    >
                      {item.name}
                      <i className="ri-arrow-down-s-line ml-1"></i>
                    </Link>
                    
                    {/* Dropdown Menu */}
                    {isProductsDropdownOpen && (
                      <div className="absolute top-full left-0 mt-1 w-80 bg-slate-800 border border-slate-700 rounded-lg shadow-xl z-50">
                        <div className="py-2">
                          {productCategories.map((category) => (
                            <div key={category.name} className="group">
                              <Link
                                to={category.href}
                                className="block px-4 py-2 text-gray-300 hover:text-orange-400 hover:bg-slate-700 transition-colors font-medium border-b border-slate-700/50"
                              >
                                {category.name}
                              </Link>
                              <div className="pl-6 pb-2">
                                {category.subCategories.map((subCategory) => (
                                  <Link
                                    key={subCategory.name}
                                    to={subCategory.href}
                                    className="block px-2 py-1 text-sm text-gray-400 hover:text-orange-300 hover:bg-slate-700/50 transition-colors rounded"
                                  >
                                    • {subCategory.name}
                                  </Link>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={item.href}
                    className={`text-lg font-medium transition-colors hover:text-orange-400 ${
                      location.pathname === item.href ? 'text-orange-400' : 'text-gray-300'
                    }`}
                  >
                    {item.name}
                  </Link>
                )}
              </div>
            ))}
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-700">
            <nav className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <div key={item.name}>
                  <Link
                    to={item.href}
                    className={`text-lg font-medium transition-colors hover:text-orange-400 ${
                      location.pathname === item.href ? 'text-orange-400' : 'text-gray-300'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                  {item.hasDropdown && (
                    <div className="ml-4 mt-2 space-y-2">
                      {productCategories.map((category) => (
                        <div key={category.name}>
                          <Link
                            to={category.href}
                            className="block text-gray-400 hover:text-orange-400 transition-colors font-medium"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            {category.name}
                          </Link>
                          <div className="ml-4 mt-1 space-y-1">
                            {category.subCategories.map((subCategory) => (
                              <Link
                                key={subCategory.name}
                                to={subCategory.href}
                                className="block text-sm text-gray-500 hover:text-orange-300 transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                              >
                                • {subCategory.name}
                              </Link>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
